import { Box, Typography, useTheme } from "@mui/material";
import ISONumber from "components/formatting/ISONumber";
import TitleCase from "components/formatting/TitleCase";
import React from "react";
import { useTranslation } from "react-i18next";
import { KeywordDisplayType, TimeOfDayOfWeekSettingsStateType } from "./TimeOfDayOfWeekSettings";
import { getTimeOfDayOfWeekRowContent } from "./TimeOfDayOfWeekContent";

export interface TimeOfDayOfWeekTooltipProps {
  hoveredIndex: number | undefined;
  dateFieldLabel?: string;
  fieldLabel?: string;
  topFieldValueLabel?: string;
  bottomFieldValueLabel?: string;
  displayTitle?: string;
  settingsState: TimeOfDayOfWeekSettingsStateType;
  topField?: string;

  content : {
    maxValue: number,
    minValue: number,
    dayOfWeekLabels: string[],
    rows: { value: number, original: any, color: string }[]
  }
}

export default function TimeOfDayOfWeekTooltip(props: TimeOfDayOfWeekTooltipProps): React.JSX.Element | null {
  const theme = useTheme();
  const { i18n } = useTranslation();

  const { hoveredIndex, content } = props;

  if (hoveredIndex === undefined || !content.rows[hoveredIndex]) {
    return null;
  }

  const row = content.rows[hoveredIndex];
  const contentRow = getTimeOfDayOfWeekRowContent(row.original, props.settingsState, props.topField);

  return (
    <Box>
      <Typography sx={{ fontWeight: "bold", mb: 1 }}>
        {props.displayTitle || props.fieldLabel || i18n.t("value")}
      </Typography>

      <Typography sx={{mb: 1}}>
        {`${props.dateFieldLabel ? props.dateFieldLabel : i18n.t("date-time")}: `}
        <Box sx={{ display: "inline-block", ml: 1, fontWeight: "bold", color: theme.colors.primary.main }}>
          <TitleCase text={row.original._label}/>
        </Box>
      </Typography>
      <Typography>
        {(props.settingsState.keywordDisplayType === KeywordDisplayType.NET && contentRow.topValue !== undefined && contentRow.bottomValue !== undefined) && i18n.t("net") + " "}
        {i18n.t("value")}:
        <Box sx={{ display: "inline-block", ml: 1, color: theme.colors.primary.main, fontWeight: "bold" }}>
          <ISONumber number={row.value} sx={{ fontWeight: "bold" }}/>
        </Box>
      </Typography>

      {(props.settingsState.keywordDisplayType === KeywordDisplayType.NET && contentRow.topValue !== undefined && contentRow.bottomValue !== undefined) && (<>
        <Typography>
          {i18n.t("widget-types.time-of-day-of-week.settings.top-value")}:
          <Box sx={{ display: "inline-block", ml: 1, color: props.settingsState.maxColor || "inherit", fontWeight: "bold" } }>
            <ISONumber number={contentRow.topValue} sx={{ fontWeight: "bold" }}/>
          </Box>
        </Typography>
        <Typography>
          {i18n.t("widget-types.time-of-day-of-week.settings.bottom-value")}:
          <Box sx={{ display: "inline-block", ml: 1, color: props.settingsState.minColor || "inherit", fontWeight: "bold" } }>
            <ISONumber number={contentRow.bottomValue} sx={{ fontWeight: "bold" }}/>
          </Box>
        </Typography>
      </>)}
    </Box>
  );
}